import { ca } from '@cian/analytics';

export function trackLabelClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'Booking_click_label',
    label,
    useLastProducts: true,
    page: {
      extra: {
        main_label: true,
      },
    },
  });
}
